export let websocket: WebSocket | null = null;
let pingInterval: ReturnType<typeof setInterval> | null = null;
let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
let closed = false;


export const connectWebsocket = () => {
  const token = LocalStorage.jwt.value;
  const authStore = useAuthStore();
  if (!authStore.isAuthenticated || !token) return;

  if (websocket) return websocket;
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }

  closed = false;
  const config = useRuntimeConfig();
  const wsUrl = String(config.public.apiUrl).replace(/^http/, "ws");
  websocket = new WebSocket(`${wsUrl}/ws?token=${token}`);

  websocket.onopen = () => {
    pingInterval = setInterval(() => {
      if (websocket) websocket.send("ping");
    }, 1000 * 30);
  };

  websocket.onmessage = (event) => {
    eventBus.emit("ws:event", JSON.parse(event.data));
  };

  websocket.onclose = () => {
    if (pingInterval) clearInterval(pingInterval);
    pingInterval = null;
    websocket = null;
    if (closed || !useAuthStore().isAuthenticated) return;
    reconnectTimer = setTimeout(() => connectWebsocket(), 2000);
  };

  return websocket;
};


export const disconnectWebsocket = () => {
  closed = true;
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
  if (websocket) {
    websocket.close();
    websocket = null;
  }
  if (pingInterval) {
    clearInterval(pingInterval);
    pingInterval = null;
  }
};
